import { createApp } from "vue"
import App from "./App.vue"
import Toast, { POSITION, } from "vue-toastification"
import "vue-toastification/dist/index.css";
import router from "./router.js"
import axios from "axios"
import VueCookies from "vue3-cookies"

axios.defaults.baseURL = "/api";

const toastOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  pauseOnFocusLoss: true
};

const app = createApp(App);
app.use(router).use(VueCookies).use(Toast, toastOptions);

app.mount("#app");
